import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuelidate from "vuelidate";
import VModal from "vue-js-modal";
import VueMoment from "vue-moment";
import moment from 'moment-timezone'
import { ToastPlugin } from "bootstrap-vue";
import IdleVue from "idle-vue";
import VueChatScroll from "vue-chat-scroll";
import Toasted from "vue-toasted";
import { ModalPlugin } from "bootstrap-vue";

Vue.config.productionTip = false;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 60000,
});

const token = sessionStorage.getItem("token");
if (token) {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
}

Vue.use(VueAxios, axiosInstance);
Vue.use(Vuelidate);
//Vue.use(VueMoment);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VModal, { dialog: true });
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(VueChatScroll);
Vue.use(Toasted, {
  iconPack: "fontawesome", // set your iconPack, defaults to material. material|fontawesome|custom-class
});
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  events: ["keydown", "mousedown", "touchstart"],
  idleTime: 90 * 60 * 1000, // 1.5 HOUR
  startAtIdle: false,
  store,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
